"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pezzaze": {
    "1b3447ff": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "skipSearch": false
    }],
    "canelli": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "683744c6": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-san-zeno": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "058dd2d0": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "skipSearch": false
    }],
    "etto": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "220225b3": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "skipSearch": false
    }],
    "mondaro": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1a652b3": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "skipSearch": false
    }],
    "monte": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd3ad3c2": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "skipSearch": false
    }],
    "pezzazole": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0d88bac": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "skipSearch": false
    }],
    "sant-apollonio": [{
      "hkey": "de263b33",
      "slug": "pezzaze",
      "name": "Pezzaze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;